import { geminiThinkingBudget } from '../constants/enum';

/**
 * OCRコスト表示まわりの表示名ヘルパー（#3315）。
 *
 * もともと PatternAiOcrResult.tsx のモジュール内関数だったが、
 * フリーOCRの結果画面でも同じコスト内訳を出すため共通化した。
 */

// OCRエンジンの表示名を取得する（#2960）
// token_usage.azure_vision.engine の文字列から表示名を引く。未設定（過去データ）は Vision AI
export const getOcrEngineDisplayName = (engine?: string): string => {
  switch (engine) {
    case 'document-intelligence':
      return 'Document Intelligence';
    case 'document-intelligence-tables':
      return 'DI + 表構造';
    case 'gemini-only':
      return 'Gemini のみ';
    default:
      return 'Vision AI';
  }
};

// 思考設定の表示名を取得する
export const getThinkingConfigDisplayName = (
  thinkingBudget?: number | null,
  thinkingLevel?: string | null,
): string => {
  // Gemini 3用: thinkingLevel
  if (thinkingLevel) {
    switch (thinkingLevel) {
      case 'minimal':
        return '思考：最小';
      case 'low':
        return '思考：低';
      case 'medium':
        return '思考：中';
      case 'high':
        return '思考：高';
      default:
        return `思考：${thinkingLevel}`;
    }
  }

  // Gemini 2.5用: thinkingBudget
  if (thinkingBudget !== undefined && thinkingBudget !== null) {
    switch (thinkingBudget) {
      case geminiThinkingBudget.disabled:
        return '思考：無効';
      case geminiThinkingBudget.auto:
        return '思考：自動';
      case geminiThinkingBudget.minimal:
        return '思考：最小';
      case geminiThinkingBudget.low:
        return '思考：低';
      case geminiThinkingBudget.medium:
        return '思考：中';
      case geminiThinkingBudget.high:
        return '思考：高';
      case geminiThinkingBudget.max:
        return '思考：最大';
      default:
        return `思考：${thinkingBudget}`;
    }
  }

  return '';
};

// トークン単価をフォーマット（例: 0.30 → $0.30/1M）
export const formatTokenPrice = (pricePerMillion?: number): string => {
  if (pricePerMillion === undefined || pricePerMillion === 0) return '$0';
  return `$${pricePerMillion.toFixed(2)}/1M`;
};

/**
 * 保存済みのモデル名文字列を、画面表示用の名前に整える（#3375）。
 *
 * token_usage.gemini_ocr.model_name / gemini_structured.model_name のように
 * 実行時のモデル名がそのまま入っているフィールドを人が読める形にする。
 * 該当がなければモデル名をそのまま返す（新しいモデルでも表示が消えないように）。
 */
export const getModelNameDisplay = (modelName?: string): string => {
  if (!modelName) return '';
  if (modelName.includes('gpt-4o')) return 'ChatGPT（GPT-4o）';
  // Flash-Lite は Flash より先に判定する（3.5-flash-lite が 3.5-flash を含むため）
  if (modelName.includes('3.5-flash-lite')) return 'Gemini 3.5 Flash-Lite';
  if (modelName.includes('3.1-flash-lite')) return 'Gemini 3.1 Flash-Lite';
  if (modelName.includes('2.5-flash-lite')) return 'Gemini 2.5 Flash-Lite';
  if (modelName.includes('3.6-flash')) return 'Gemini 3.6 Flash';
  if (modelName.includes('3.5-flash')) return 'Gemini 3.5 Flash';
  if (modelName.includes('2.5-flash')) return 'Gemini 2.5 Flash';
  if (modelName.includes('2.5-pro')) return 'Gemini 2.5 Pro';
  if (modelName.includes('3.1-pro') || modelName.includes('3-pro')) return 'Gemini 3.1 Pro';
  if (modelName.includes('3-flash')) return 'Gemini 3 Flash';
  return modelName;
};
